import { defineMessages } from 'react-intl';

const badgeColorMessages = defineMessages({
    gray: {
        id: 'badge-gray',
        defaultMessage: 'Gray',
    },
    red: {
        id: 'badge-red',
        defaultMessage: 'Red',
    },
    orange: {
        id: 'badge-orange',
        defaultMessage: 'Orange',
    },
    yellow: {
        id: 'badge-yellow',
        defaultMessage: 'Yellow',
    },
    lime: {
        id: 'badge-lime',
        defaultMessage: 'Lime',
    },
    emerald: {
        id: 'badge-emerald',
        defaultMessage: 'Emerald',
    },
    cyan: {
        id: 'badge-cyan',
        defaultMessage: 'Cyan',
    },
    blue: {
        id: 'badge-blue',
        defaultMessage: 'Blue',
    },
    indigo: {
        id: 'badge-indigo',
        defaultMessage: 'Indigo',
    },
    violet: {
        id: 'badge-violet',
        defaultMessage: 'Violet',
    },
    purple: {
        id: 'badge-purple',
        defaultMessage: 'Purple',
    },
    fuchsia: {
        id: 'badge-fuchsia',
        defaultMessage: 'Fuchsia',
    },
});

const membershipMessages = defineMessages({
    membershipGroups: {
        id: 'membership-groups',
        defaultMessage: 'Parking memberships',
    },
    membership: {
        id: 'membership',
        defaultMessage: 'Membership',
    },
    memberships: {
        id: 'memberships',
        defaultMessage: 'Memberships',
    },
    editMembership: {
        id: 'edit-membership',
        defaultMessage: 'Edit membership',
    },
    copyMembership: {
        id: 'copy-membership',
        defaultMessage: 'Copy membership',
    },
    copyMembershipDescription: {
        id: 'copy-membership-description',
        defaultMessage: 'Copy membership to create a new one',
    },
    addMembership: {
        id: 'add-membership',
        defaultMessage: 'Add membership',
    },
    validFrom: {
        id: 'valid-from',
        defaultMessage: 'Valid from',
    },
    validUntil: {
        id: 'valid-until',
        defaultMessage: 'Valid until',
    },
    validDays: {
        id: 'valid-days',
        defaultMessage: 'Valid days',
    },
    allowedDays: {
        id: 'allowed-days',
        defaultMessage: 'Allowed days',
    },
    allowedHours: {
        id: 'allowed-hours',
        defaultMessage: 'Allowed hours',
    },
    allowedParkings: {
        id: 'allowed-parkings',
        defaultMessage: 'Allowed zones',
    },
    allowedParkingsPlaceholder: {
        id: 'allowed-parkings-placeholder',
        defaultMessage: 'Choose allowed zones',
    },
    allowedPoints: {
        id: 'allowed-points',
        defaultMessage: 'Allowed points',
    },
    allowedPointGroup: {
        id: 'allowed-point-group',
        defaultMessage: 'Allowed group points',
    },
    allowedParkingPlaces: {
        id: 'allowed-parking-places',
        defaultMessage: 'Parking Spots',
    },
    accessLevel: {
        id: 'access-level',
        defaultMessage: 'Access level',
    },
    accessLevelPlaceholder: {
        id: 'access-level-placeholder',
        defaultMessage: 'Select access level...',
    },
    accessLevelTip: {
        id: 'access-level-tip',
        defaultMessage:
            '<p><b>Owners</b> - edit participants and edit vehicles.</p><p><b>Members</b> - edit vehicles.</p><p><b>Guests</b> - view only.</p>',
    },
    owners: {
        id: 'owners',
        defaultMessage: 'Owners',
    },
    fullDay: {
        id: 'full-day',
        defaultMessage: 'Full day',
    },
    updateMembershipGroupSuccess: {
        id: 'update-membership-group-success',
        defaultMessage: 'Parking membership updated',
    },
    updateMembershipGroupSuccessDescription: {
        id: 'update-membership-group-success-description',
        defaultMessage: 'Parking membership for vehicle {membershipGroupName} has been successfully updated.',
    },
    updateMembershipRoleSuccessDescription: {
        id: 'update-membership-role-success-description',
        defaultMessage: 'Parking membership role has been successfully updated.',
    },
    createMembershipGroupSuccess: {
        id: 'create-membership-group-success',
        defaultMessage: 'Parking membership created',
    },
    createMembershipGroupSuccessDescription: {
        id: 'create-membership-group-success-description',
        defaultMessage: 'Parking membership for group {membershipGroupName} has been successfully created.',
    },
    membershipGroupNotFound: {
        id: 'membership-group-not-found',
        defaultMessage: 'Membership group not found',
    },
    membershipGroupNotFoundDescription: {
        id: 'membership-group-not-found-description',
        defaultMessage: 'The requested membership group could not be found. Try looking for another one.',
    },
    backToAllMemberships: {
        id: 'back-to-all-memberships',
        defaultMessage: 'Back to all memberships',
    },
    membershipDuration: {
        id: 'membership-duration',
        defaultMessage: 'Duration',
    },
    membershipDurationPlaceholder: {
        id: 'membership-duration-placeholder',
        defaultMessage: 'Select duration...',
    },
    allSubParkings: {
        id: 'all-sub-parkings',
        defaultMessage: 'All zones',
    },
    allPoints: {
        id: 'all-points',
        defaultMessage: 'All points',
    },
    timeFrame: {
        id: 'time-frame',
        defaultMessage: 'Time frame',
    },
    additionalVehicles: {
        id: 'additional-vehicles',
        defaultMessage: 'Additional vehicle IDs',
    },
    membershipNamePlaceholder: {
        id: 'membership-name-placeholder',
        defaultMessage: "User's membership",
    },
    membershipPointsPlaceholder: {
        id: 'membership-points-placeholder',
        defaultMessage: 'Choose allowed points',
    },
    membershipPointGroupPlaceholder: {
        id: 'membership-point-group-placeholder',
        defaultMessage: 'Choose allowed group points',
    },
    noMembershipPointGroupPlaceholder: {
        id: 'no-membership-point-group-placeholder',
        defaultMessage: 'There are no allowed group points',
    },
    members: {
        id: 'members',
        defaultMessage: 'Members',
    },
    notAMember: {
        id: 'not-a-member',
        defaultMessage: 'Not a member',
    },
    notAMemberDescription: {
        id: 'not-a-member-description',
        defaultMessage:
            'It appears that you are not a member of any current SmartPark parking. Please contact your parking administrator for more information.',
    },
    noVehicles: {
        id: 'no-vehicles',
        defaultMessage: 'No vehicles',
    },
    noVehiclesDescription: {
        id: 'no-vehicles-description',
        defaultMessage: 'There are currently no vehicles associated with this membership. Try adding a new vehicle.',
    },
    addVehicle: {
        id: 'add-vehicle',
        defaultMessage: 'Add vehicle',
    },
    addNewVehicle: {
        id: 'add-new-vehicle',
        defaultMessage: 'Add new vehicle',
    },
    editVehicles: {
        id: 'edit-vehicles',
        defaultMessage: 'Edit vehicles',
    },
    vehicles: {
        id: 'vehicles',
        defaultMessage: 'Vehicles',
    },
    vehicle: {
        id: 'vehicle',
        defaultMessage: 'Vehicle',
    },
    vehicleLicensePlate: {
        id: 'vehicle-license-plate',
        defaultMessage: 'License plate',
    },
    tags: {
        id: 'tags',
        defaultMessage: 'Vehicle tags',
    },
    tagsPlaceholder: {
        id: 'tags-placeholder',
        defaultMessage: 'Choose vehicle tags...',
    },
    tagName: {
        id: 'tag-name',
        defaultMessage: 'Tag name...',
    },
    tagColor: {
        id: 'tag-color',
        defaultMessage: 'Tag color',
    },
    createTag: {
        id: 'create-tag',
        defaultMessage: "Create new tag ''{tag}''",
    },
    saveTag: {
        id: 'save-tag',
        defaultMessage: 'Save tag',
    },
    editTags: {
        id: 'edit-tags',
        defaultMessage: 'Edit tags',
    },
    tagsSearchPlaceholder: {
        id: 'tags-search-placeholder',
        defaultMessage: 'Search or create tags...',
    },
    createMembershipGroupCardSuccess: {
        id: 'create-membership-group-card-success',
        defaultMessage: 'Vehicle added',
    },
    createMembershipGroupCardSuccessDescription: {
        id: 'create-membership-group-card-success-description',
        defaultMessage: 'Membership vehicle has been successfully added to the membership group.',
    },
    editMembershipGroupCardSuccess: {
        id: 'edit-membership-group-card-success',
        defaultMessage: 'Vehicle updated',
    },
    editMembershipGroupCardSuccessDescription: {
        id: 'edit-membership-group-card-success-description',
        defaultMessage: 'Membership vehicle has been successfully updated.',
    },
    createMembershipGroupMemberSuccess: {
        id: 'create-membership-group-member-success',
        defaultMessage: 'Member added',
    },
    createMembershipGroupMemberSuccessDescription: {
        id: 'create-membership-group-member-success-description',
        defaultMessage: 'Member has been successfully added to the membership group.',
    },
    editMembershipGroupMemberSuccess: {
        id: 'edit-membership-group-member-success',
        defaultMessage: 'Member updated',
    },
    confirmDeleteTag: {
        id: 'confirm-delete-tag',
        defaultMessage: 'Are you sure you want to delete tag {name}?',
    },
    editTag: {
        id: 'edit-tag',
        defaultMessage: 'Edit tag',
    },
    tagsEditPlaceholder: {
        id: 'tags-edit-placeholder',
        defaultMessage: 'Search or choose tag to edit...',
    },
    noTags: {
        id: 'no-tags',
        defaultMessage: 'No available tags',
    },
    noTagsDescription: {
        id: 'no-tags-description',
        defaultMessage: 'There are currently no tags available. Try creating a new tag.',
    },
    editMembershipGroupMemberSuccessDescription: {
        id: 'edit-membership-group-member-success-description',
        defaultMessage: 'Member has been successfully updated.',
    },
    deletedCard: {
        id: 'deleted-card',
        defaultMessage: 'Vehicle removed',
    },
    deleteTag: {
        id: 'delete-tag',
        defaultMessage: 'Delete tag',
    },
    createdTag: {
        id: 'created-tag',
        defaultMessage: 'Tag created',
    },
    updatedTag: {
        id: 'updated-tag',
        defaultMessage: 'Tag updated',
    },
    deletedTag: {
        id: 'deleted-tag',
        defaultMessage: 'Tag deleted',
    },
    failedToCreateCardTag: {
        id: 'failed-to-create-card-tag',
        defaultMessage: 'Failed to create vehicle tag',
    },
    failedToCreateCardTagDescription: {
        id: 'failed-to-create-card-tag-description',
        defaultMessage: 'Failed to create vehicle tag. Tag name must be unique for this membership group',
    },
    failedToUpdateCardTag: {
        id: 'failed-to-update-card-tag',
        defaultMessage: 'Failed to update vehicle tag',
    },
    failedToUpdateCardTagDescription: {
        id: 'failed-to-update-card-tag-description',
        defaultMessage: 'Failed to update vehicle tag. Tag name must be unique for this membership group',
    },
    editMember: {
        id: 'edit-member',
        defaultMessage: 'Edit member',
    },
    removeMember: {
        id: 'remove-member',
        defaultMessage: 'Remove member',
    },
    confirmRemoveMember: {
        id: 'confirm-remove-member',
        defaultMessage: 'Are you sure you want to remove {name} as a member of this group?',
    },
    addMember: {
        id: 'add-member',
        defaultMessage: 'Add member',
    },
    addNewMember: {
        id: 'add-new-member',
        defaultMessage: 'Add a new member to your membership group',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    memberEmailMessage: {
        id: 'member-email-message',
        defaultMessage:
            'Email of the user you would like to invite to your membership group. They will receive an email and will need to follow the instructions.',
    },
    invitedUser: {
        id: 'invited-user',
        defaultMessage: 'Invited user',
    },
    deletedMember: {
        id: 'deleted-member',
        defaultMessage: 'Member has been removed',
    },
    noMembers: {
        id: 'no-members',
        defaultMessage: 'No members',
    },
    noMembersDescription: {
        id: 'no-members-description',
        defaultMessage: 'There are currently no members associated with this membership. Try adding a new member.',
    },
    yourMembership: {
        id: 'your-membership',
        defaultMessage: 'Your membership at a glance',
    },
    accessLevelAdmin: {
        id: 'access-level-admin',
        defaultMessage: 'Owner',
    },
    accessLevelMember: {
        id: 'access-level-member',
        defaultMessage: 'Member',
    },
    accessLevelGuest: {
        id: 'access-level-guest',
        defaultMessage: 'Guest',
    },
    inParking: {
        id: 'in-parking',
        defaultMessage: 'In parking',
    },
    outOfParking: {
        id: 'out-of-parking',
        defaultMessage: 'Out of parking',
    },
    addNewMembership: {
        id: 'add-new-membership',
        defaultMessage: 'Add new membership',
    },
    editMembershipSubtitle: {
        id: 'edit-membership-subtitle',
        defaultMessage: 'Edit membership {entry}',
    },
    deleteMembership: {
        id: 'delete-membership',
        defaultMessage: 'Delete membership',
    },
    deleteMembershipName: {
        id: 'delete-membership-name',
        defaultMessage: 'Delete membership {name}',
    },
    confirmDeleteMembership: {
        id: 'confirm-delete-membership',
        defaultMessage: 'Are you sure you want to delete membership {name}? This action cannot be undone.',
    },
    membershipDeleted: {
        id: 'membership-deleted',
        defaultMessage: 'Membership deleted',
    },
    membershipDeletedSuccessfully: {
        id: 'membership-deleted-successfully',
        defaultMessage: 'Membership {name} was successfully deleted',
    },
    membershipDeleteError: {
        id: 'membership-deleted-error',
        defaultMessage:
            'Membership {name} can not be deleted - 1 or more vehicles associated with this membership are currently in the parking lot.',
    },
    tagsColumn: {
        id: 'tags-column',
        defaultMessage: 'Tags',
    },
    editVehicle: {
        id: 'edit-vehicle',
        defaultMessage: 'Edit vehicle',
    },
    editVehicleDescription: {
        id: 'edit-vehicle-description',
        defaultMessage: 'Edit vehicle {vehicleNumber}',
    },
    addVehicleDescription: {
        id: 'add-vehicle-description',
        defaultMessage: 'Add vehicle to {membershipName} membership',
    },
    deleteVehicle: {
        id: 'delete-vehicle',
        defaultMessage: 'Delete vehicle',
    },
    deleteVehicleDescription: {
        id: 'delete-vehicle-description',
        defaultMessage: 'Delete vehicle {vehicleNumber}',
    },
    confirmDeleteVehicle: {
        id: 'confirm-delete-vehicle',
        defaultMessage: 'Are you sure you want to delete vehicle {name} from this membership?',
    },
    reservedPlace: {
        id: 'reserved-place',
        defaultMessage: 'Reserved place',
    },
    cardNumberExists: {
        id: 'card-number-exists',
        defaultMessage: 'This card number has already been added to a membership group.',
    },
    activePeriod: {
        id: 'active-period',
        defaultMessage: 'Active period',
    },
    filterByActivePeriod: {
        id: 'filter-by-active-period',
        defaultMessage: 'Filter by active period',
    },
    description: {
        id: 'description',
        defaultMessage: 'Description',
    },
    membershipCardExceedingDueAmount: {
        id: 'membership-card-exceeding-due-amount',
        defaultMessage: 'The due amount with tax for this card exceeds 10 BGN!',
    },
    membershipCardExceedingDueAmountGuest: {
        id: 'membership-card-exceeding-due-amount-guest',
        defaultMessage: '"The due amount with tax for this card should be payed by guests!"',
    },
});

export { membershipMessages, badgeColorMessages };
